import { useSelector } from 'react-redux';

const useUserRole = () => useSelector(state => state.userInfo && state.userInfo.role);

export default useUserRole;
